import { useEffect, useMemo } from 'react';

import { useChallengeCelebrationModalQuery } from './graphql/ChallengeCelebrationModal.query.generated';

/**
 * Fetches challenge celebration data for the given order.
 * Fires once per orderId change; paused until the effect triggers.
 */
export const useChallengeCelebration = (orderId: string) => {
  const [{ data, fetching }, executeQuery] = useChallengeCelebrationModalQuery({
    pause: true,
    requestPolicy: 'cache-and-network',
  });

  // Fire the query imperatively so the effect (not the render cycle) controls
  // when the network request is made, preventing duplicate requests.
  useEffect(() => {
    executeQuery();
  }, [orderId, executeQuery]);

  const celebration = data?.challengeCelebrationV2;

  return useMemo(() => ({ celebration, fetching }), [celebration, fetching]);
};
